import React from 'react'
import styled from 'styled-components'

import GetReward from './components/getReward/GetReward'
import { ConfigurationManager, DropOffLocationManager, ModalManager, ThemeManager } from './components/manager'
import GeolocationManager from './components/manager/GeolocationManager'
import MapManager from './components/manager/MapManager'
import MapContainer from './components/map/MapContainer'
import BottomDrawer from './components/mobile/BottomDrawer'
import SideMenu from './components/sideMenu/SideMenu'
import SubmitDropoff from './components/submitDropoff/SubmitDropoff'
import { TENANT_ID } from './core/application/config'
import { AppProviderContext } from './core/application/contexts'
import { createDependencies } from './core/application/dependencies'
import { useMediaQuery } from './core/application/hooks'
import { deviceSizes } from './core/application/theme/breakpoints'
import './fonts.css'
import './minireset.css'

const dependencies = createDependencies()

const App: React.FC = () => {
  const { searchParams } = new URL(window.location.href)
  const isMobile = useMediaQuery(parseInt(deviceSizes.tablet))

  const tenantId = window.tenantId || searchParams.get('tenantId') || TENANT_ID
  return (
    <AppProviderContext.Provider
      value={{
        dropOffProvider: dependencies.dropOffProvider,
        tenantProvider: dependencies.tenantProvider,
        wasteTypeProvider: dependencies.wasteTypeProvider,
        dropOffTypeProvider: dependencies.dropOffTypeProvider,
        geolocationProvider: dependencies.geolocationProvider,
        geocodingProvider: dependencies.geocodingProvider,
        newDropoffProvider: dependencies.newDropoffProvider,
        multisearchProvider: dependencies.multisearchProvider,
        rewardProvider: dependencies.rewardProvider
      }}
    >
      <ConfigurationManager tenantId={tenantId}>
        <ThemeManager>
          <MapManager>
            <DropOffLocationManager>
              <ModalManager>
                <Container>
                  <GeolocationManager>
                    <SubmitDropoff />
                    <GetReward />
                    {isMobile ? <BottomDrawer /> : <SideMenu />}
                    <MapContainer />
                  </GeolocationManager>
                </Container>
              </ModalManager>
            </DropOffLocationManager>
          </MapManager>
        </ThemeManager>
      </ConfigurationManager>
    </AppProviderContext.Provider>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  height: 100%;
  width: 100%;
  position: relative;
  overflow-y: hidden;
`

export default App
